import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api, toApiErrorMessage} from "utils/http"

interface DataProps {
    id: number
    rejection_reason: string
}

export const rejectApplication = createAsyncThunk<
    void,
    DataProps,
    AppThunkProps & {rejectValue: string | undefined}
>("application/reject", async ({id, rejection_reason}, {signal, rejectWithValue}) => {
    try {
        await api.patch<void>(`/applications/${id}/decline`, {rejection_reason}, {signal})
    } catch (error) {
        // Без rejectWithValue текст ошибки от бэкенда теряется при сериализации
        return rejectWithValue(toApiErrorMessage(error))
    }
})
